import moment from 'moment';
import { useEffect, useState } from 'react';
import {
  getListCampaign,
  getUserAffiliationInfo,
} from '../features/dashboard/actions';
import { isEmpty } from '../utils/helpers/helpers';

function useDashBoard(props) {
  const [filterType, setFilterType] = useState('all');
  const [filterDate, setFilterDate] = useState([
    moment().subtract(3, 'month'),
    moment(),
  ]);
  const [listCampaign, setListCampaign] = useState([]);
  const [userAffiliationInfo, setUserAffiliationInfo] = useState({});
  useEffect(() => {
    const dataDto = {
      from: filterDate[0].format('HH:mm:ss DD-MM-YYYY'),
      to: filterDate[1].format('HH:mm:ss DD-MM-YYYY'),
    };
    fetListCampaign(dataDto);
    fetUserAffiliationInfo();
    props.actionGeneralInfo();
    props.actionGetListBank();
    // eslint-disable-next-line
  }, []);
  const fetListCampaign = async (dataDto) => {
    try {
      const { data } = await getListCampaign(dataDto);
      if (data.code === 200) {
        setListCampaign(data.data.affiliationCampaignStatisticList || []);
      }
    } catch (error) {}
  };
  const fetUserAffiliationInfo = async () => {
    try {
      const { data } = await getUserAffiliationInfo();
      if (data.code === 200) {
        setUserAffiliationInfo(data.data || {});
      } else {
      }
    } catch (error) {}
  };

  const onChange = (value) => {
    setFilterType(value);
    let dataDto = {
      from: filterDate[0].format('HH:mm:ss DD-MM-YYYY'),
      to: filterDate[1].format('HH:mm:ss DD-MM-YYYY'),
    };
    if (value !== 'all') {
      dataDto = {
        ...dataDto,
        type: value,
      };
    }
    fetListCampaign(dataDto);
  };

  const onChangeDate = (date) => {
    setFilterDate(date);
    let dataDto = {
      from: date[0].format('HH:mm:ss DD-MM-YYYY'),
      to: date[1].format('HH:mm:ss DD-MM-YYYY'),
    };
    if (filterType !== 'all') {
      dataDto = {
        ...dataDto,
        type: filterType,
      };
    }
    fetListCampaign(dataDto);
  };
  const getInfoGeneralInfo = () => {
    let info = {};
    if (!isEmpty(props.generalInfo?.affiliationLevels)) {
      const levelSelect = props.generalInfo?.affiliationLevels.find(
        (el) => el.level === userAffiliationInfo.currentLevel
      );
      const levelSelectNext = props.generalInfo?.affiliationLevels.find(
        (el) => el.level === userAffiliationInfo.currentLevel + 1
      );
      if (!isEmpty(levelSelect)) {
        info = {
          gmvto: levelSelect.gmvto,
          discount: levelSelect?.affiliationCommissions.find(
            (el) => el.module === 'hotel'
          ),
          discountFlight: levelSelect?.affiliationCommissions.find(
            (el) => el.module === 'flight'
          ),
          discountGrocery: levelSelect?.affiliationCommissions.find(
            (el) => el.module === 'grocery'
          ),
        };
      }
      if (!isEmpty(levelSelectNext)) {
        info = {
          ...info,
          gmvUp: levelSelectNext.gmvfrom,
        };
      }
    }
    return info;
  };
  return {
    filterType,
    filterDate,
    setFilterDate,
    listCampaign,
    userAffiliationInfo,
    onChange,
    onChangeDate,
    getInfoGeneralInfo,
    fetListCampaign,
  };
}

export default useDashBoard;
